// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { Badge } from '@shopify/polaris';
import * as AppIntegrationActions from 'actions/app-integration-actions';

type Props = {
  index: number,
  icon: number,
  name: number,
  appListingURL: string,
  description: string,
  instructionURL: string
};

type ComposedProps = Props & WithI18nProps;

class AliCard extends Component<ComposedProps> {
  state = {};

  componentDidMount() {
    const { supportAliReview } = this.props;

    this.setState({ supportAliReview });
  }

  render() {
    const { i18n, data = {}, index, supportAliReview, themeSetupV2, themeSetupV3 } = this.props;
    const { icon, name, appType, appName, integration, appListingURL, description, iconStyle } =
      data;

    return (
      <div className={index === 1 ? 'item middle' : 'item'}>
        <div className="item-header">
          <a
            className="Polaris-Link"
            href={appListingURL}
            target="_blank"
            rel="noopener noreferrer">
            <img
              className="icon"
              src={icon}
              alt={i18n.translate(name)}
              style={iconStyle ? iconStyle : {}}
            />
          </a>
        </div>

        {/* App name */}
        <p className="name">{i18n.translate(name)}</p>

        {/* App description */}
        <p className="description">{i18n.translate(description)}</p>

        {/*Enable/Disable app key*/}
        {(themeSetupV2 || themeSetupV3) && (
          <div className="BC-Checkbox-Status__Wrapper">
            {/* Integration type */}
            {(themeSetupV2 || themeSetupV3) && integration && (
              <div className="integration">
                <Badge status="info">{i18n.translate(integration)}</Badge>
              </div>
            )}

            <label className="BC-Checkbox-Status">
              <input
                type="checkbox"
                checked={supportAliReview}
                onChange={() => this.handleChange(appType, appName)}
              />
              <span />
            </label>
          </div>
        )}

        {/* App instruction */}
        {/* <div className="instruction">
          {i18n.translate('AdminHTML.Integration.Integration.instruction', {
            t: (
              <Link external url={instructionURL}>
                {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                  nt_name: i18n.translate(name)
                })}
              </Link>
            )
          })}
        </div> */}
      </div>
    );
  }

  // Change status
  handleChange = (appType, appName) => {
    const { currentAppIntegration } = this.props;

    this.props.handleChangeApp(currentAppIntegration, appType, appName);
  };
}

const mapDispatchToProps = dispatch => ({
  handleChangeApp: (currentAppIntegration, appType, appName) =>
    dispatch(AppIntegrationActions.handleChangeApp(currentAppIntegration, appType, appName))
});

const mapStateToProps = state => {
  const supportAliReview = _.get(state.oauth.tenantApp, 'parseParams.supportAliReview', false);

  // Get current app review integration
  const currentAppIntegration = _.get(state.oauth.tenantApp, 'currentAppIntegration', {});

  // Show/hide by themeSetupV2
  const themeSetupV2 = _.get(state.oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false);
  const themeSetupV3 = _.get(state.oauth, 'tenantApp.settings.themeSetupV3.settings.enable', false);
  return {
    supportAliReview,
    themeSetupV2,
    themeSetupV3,
    currentAppIntegration
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(AliCard));
